module.exports = __webpack_public_path__ + "img/activity1_2024.d12aa06c.png";